import { render } from "./Logo.vue?vue&type=template&id=9b23653a"
const script = {}

import exportComponent from "/Users/chrisu/Documents/CHRISUmedia/repos/Laravel/pingcrm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__